
const errors = {
    400: 'Error de formulario',
    401: 'Credenciales expiradas',
    403: 'No tienes permisos',
    404: 'No encontrado'
}

export default errors;